import styled from "@emotion/styled";
import {colors} from "../ui";
import React from "react";
import {Flex} from "../ui";

export const serialize = (obj, prefix) => {
    var str = [],
        p;
    for (p in obj) {
        if (obj.hasOwnProperty(p)) {
        var k = prefix ? prefix + "[" + p + "]" : p,
            v = obj[p];
        str.push((v !== null && typeof v === "object") ?
            serialize(v, k) :
            encodeURIComponent(k) + "=" + encodeURIComponent(v));
        }
    }
    return str.join("&");
}

export const valueOrDashes = (value) => {
    return value ? value : "---------------"
}

export const Line = styled.div`
  border-bottom: 1px ${props => (props.dotted ? "dotted " : "solid ")}
    ${colors.title};
  width: 100%;
  `;

export const ToastS = styled(Flex)`
  border: 2px solid ${props => props.borde};
  background:${props => props.bg};
  height:auto;
  border-radius:4px;
  font-size:14px;
  
  img{
    height:25px;
    width:auto;
    display:block;
  }`;


export const TextsStates = {
    paymentAndSuscription:{
        aceptada  : "SUSCRIPCION ACTIVA Y PAGO APROBADO",
        rechazada : "SUSCRIPCIÓN RECHAZADA Y PAGO RECHAZADO",
        fallida   : "SUSCRIPCIÓN RECHAZADA Y PAGO RECHAZADO",
        pendiente : "SUSCRIPCIÓN PENDIENTE Y PAGO PENDIENTE"
    },
    paymentAndSuscriptionDebit:{
        Aceptada  : {text:"SUSCRIPCION PENDIENTE Y PAGO APROBADO", color:"alertY"},
        Rechazada : {text:"SUSCRIPCIÓN PENDIENTE Y PAGO RECHAZADO",color:"alertR"},
        Fallida   : {text:"SUSCRIPCIÓN PENDIENTE Y PAGO RECHAZADO",color:"alertR"},
        Pendiente : {text:"SUSCRIPCIÓN PENDIENTE Y CUENTA DÉBITO PENDIENTE",color:"alertY"}
    },
    suscription:{
        aceptada  : "SUSCRIPCIÓN ACTIVA",
        rechazada : "SUSCRIPCIÓN RECHAZADA",
        fallida   : "SUSCRIPCIÓN RECHAZADA",
        pendiente : "SUSCRIPCIÓN PENDIENTE",
    }
};

export const Toast = ({type,mensaje,close})=>{

    let types = {
        success:{
            borde:"#a5d6a7",
            bg:"#e8f5e9",
            icon:"checked",
        },
        error:{
            borde:"#ef9a9a",
            bg:"#ffebee",
            icon:"forbidden",
        },
        warning:{
            borde:"#fff59d",
            bg:"#fffde7",
            icon:"warning",
        },
        info:{
            borde:"#81d4fa",
            bg:"#e1f5fe",
            icon:"information",
        },
    };

    return(
        <ToastS
            borde={types[type].borde}
            bg={types[type].bg}
            className={"p-2"}
        >
            <Flex elastic={"0 0 30px"}>
                <img src={`https://multimedia-epayco.s3.amazonaws.com/dashboard/alerts-icons/${types[type].icon}.png`} alt=""/>
            </Flex>
            <Flex elastic={"1 0 80%"} jc={"flex-start"} className={"pl-3"}>
                {mensaje}
            </Flex>
            {close &&
            <Flex elastic={"0 0 30"} jc={"flex-start"}>
                <i className="fa fa-times"></i>
            </Flex>
            }
        </ToastS>
    )
};


export const Itemdata = ({name,value,noline})=>{
    return(
        <Flex className={"wc pt-2"}>
            <Flex elastic={"1 0 45%"} jc={"flex-start"}>
                <small> {name}</small>
            </Flex>
            <Flex elastic={"1 0 auto"} jc={"flex-end"}>
                <small>{value}</small>
            </Flex>

            {!noline &&
            <Line dotted/>
            }
        </Flex>
    )
};

export const DataBlock = ({title,data = [] })=>{
    return(
        <Flex elastic={"1 0 250px"} className={"p-3"}>
            <div className="wc">
                <small className={"mb-2 d-block"}><strong>{title}</strong></small>
                <Line dotted/>
            </div>

            {data.map((item,index)=>
                <Itemdata
                    key={index}
                    name={item.name ||   "-------------"}
                    value={item.value || "-------------"}
                    noline={item.noline}
                />
            )}
        </Flex>
    )
};
